import { useEffect, useState } from "react"

import { loadTerminalPortfolios } from "@/actions/terminal-file-actions"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import type { TerminalPortfolioOption } from "@/lib/terminal/file-view"

// Every Portfolio, loaded once the caller needs it.
export const usePortfolios = (isNeeded = true) => {
  const [portfolios, setPortfolios] = useState<TerminalPortfolioOption[]>()
  useEffect(() => {
    if (isNeeded && !portfolios)
      void loadTerminalPortfolios().then(setPortfolios)
  }, [isNeeded, portfolios])
  return portfolios ?? []
}

export const OptionSelect = ({
  label,
  value,
  options,
  isDisabled = false,
  onChange,
}: {
  label: string
  value: string
  options: { value: string; label: string }[]
  isDisabled?: boolean
  onChange: (value: string) => void
}) => (
  <Select value={value} onValueChange={onChange} disabled={isDisabled}>
    <SelectTrigger aria-label={label} className="h-8 w-36 text-xs">
      <SelectValue placeholder={label} />
    </SelectTrigger>
    <SelectContent>
      {options.map((option) => (
        <SelectItem key={option.value} value={option.value} className="text-xs">
          {option.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
)

const MONITORED = "monitored"

// Monitored follows every new File; a snapshot pins one.
export const ModeSelect = ({
  label = "Mode",
  isMonitoring,
  isDisabled,
  onChange,
}: {
  label?: string
  isMonitoring: boolean
  isDisabled?: boolean
  onChange: (isMonitoring: boolean) => void
}) => (
  <OptionSelect
    label={label}
    value={isMonitoring ? MONITORED : "snapshot"}
    options={[
      { value: MONITORED, label: "Monitored" },
      { value: "snapshot", label: "Snapshot" },
    ]}
    isDisabled={isDisabled}
    onChange={(mode) => onChange(mode === MONITORED)}
  />
)
